const labels: Record<string, string> = {
  PENDING: 'Pendente',
  UNASSESSED: 'Por avaliar',
  BLOCKED: 'Bloqueada',
  IN_REVIEW: 'Em análise',
  APPROVED: 'Aprovado',
  REJECTED: 'Rejeitado',
  MORE_INFORMATION_REQUIRED: 'Mais informação',
  ACTIVE: 'Ativo',
  FAILED: 'Com erro',
  SUSPENDED: 'Suspenso',
  UNAVAILABLE: 'Indisponível',
  LOW: 'Baixo',
  MEDIUM: 'Médio',
  HIGH: 'Alto',
  SUCCESS: 'Sucesso',
  FAILURE: 'Falhou',
  COMPLETED: 'Concluído',
  REVERSED: 'Revertido',
  FROZEN: 'Congelado',
  CANCELLED: 'Cancelado',
  PHYSICAL: 'Física',
  VIRTUAL: 'Virtual',
};

export function StatusBadge({ value }: { value: string }) {
  return (
    <span className={`status status--${value.toLowerCase()}`}>
      <span className="status__dot" />
      {labels[value] ?? value}
    </span>
  );
}
